import { createVNode, createTextVNode } from "inferno";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import { Component } from 'inferno'; // eslint-disable-next-line

var logo = 'iVBORw0KGgoAAAANSUhEUgAAADQAAAA0CAMAAADypuvZAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAADBQTFRFiMte9PrwldFwfcZPqtqN0+zEyOe1XLgjvuKncsJAZ70y6fXh3vDT////UrQV////G2zN+AAAABB0Uk5T////////////////////AOAjXRkAAAHDSURBVHjavJZJkoUgDEBJmAX8979tM8u3E6x20VlYJfFFMoL4vBDxATxZcakIOJTWSmxvKWVIkJ8jHvlRv1F2LFrVISCZI+tCtQx+XfewgVTfyY3plPiQEAzI3zWy+kR6NBhFBYeBuscJLOUuA2WVLpCjVIaFzrNQZArxAZKUQm6gsj37L9Cb7dnIBUKxENaaMJQqMpDXvSL+ktxdGRm2IsKgJGGPg7atwUG5CcFUEuSv+CwQqizTrvDTNXdMU2bMiDWZd8d7QIySWVRsb2vBBioxOFt4OinPBapL+neAb5KL5IJ8szOza2/DYoipUCx+CjO0Bpsv0V6mktNZ+k8rlABlWG0FrOpKYVo8DT3dBeLEjUBAj7moDogVii7nSS9QzZnFcOVBp1g2PyBQ3Vr5aIapN91VJy33HTJLC1iX2FY6F8gRdaAeIEfVONgtFCzZTmoLEdOjBDfsIOA6128gw3eu1shAajdZNAORxuQDJN5A5PbEG6gNIu24QJD5iNyRMZIr6bsHbCtCU/OaOaSvgkUyDMdDa1BXGf5HJ1To+/Ym6mCKT02Y+/Sa126ZKyd3jxhzpc1r8zVL6YM1Qy/kR4ABAFJ6iQUnivhAAAAAAElFTkSuQmCC';

var PoweredByOverlayComponent =
/*#__PURE__*/
function (_Component) {
  _inherits(PoweredByOverlayComponent, _Component);

  function PoweredByOverlayComponent(props) {
    var _this;

    _classCallCheck(this, PoweredByOverlayComponent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PoweredByOverlayComponent).call(this, props));
    _this.state = {
      show: false
    };
    _this.onClick = _this.onClick.bind(_assertThisInitialized(_this));
    _this.onShow = _this.onShow.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(PoweredByOverlayComponent, [{
    key: "onClick",
    value: function onClick() {
      this.setState({
        show: false
      });
    }
  }, {
    key: "onShow",
    value: function onShow() {
      this.setState({
        show: true
      });
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      var eventBus = this._eventBus = this.context.injector.get('eventBus');
      eventBus.on('poweredBy.show', this.onShow);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._eventBus.off('poweredBy.show', this.onShow);
    }
  }, {
    key: "render",
    value: function render() {
      var show = this.state.show;
      return show && createVNode(1, "div", "powered-by-overlay", createVNode(1, "div", "powered-by-overlay-content", [createVNode(1, "div", null, createVNode(1, "img", "logo", null, 1, {
        "src": "data:image/png;base64,".concat(logo)
      }), 2), createVNode(1, "div", null, [createTextVNode("Web-based tooling for BPMN, DMN and CMMN diagrams powered by "), createVNode(1, "a", null, createTextVNode("bpmn.io"), 2, {
        "href": "http://bpmn.io",
        "target": "_blank"
      }), createTextVNode(".")], 4)], 4, {
        "onClick": function onClick(e) {
          return e.stopPropagation();
        }
      }), 2, {
        "onClick": this.onClick
      });
    }
  }]);

  return PoweredByOverlayComponent;
}(Component);

export { PoweredByOverlayComponent as default };
//# sourceMappingURL=PoweredByOverlayComponent.js.map